import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["defaultValue", "use"];
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { useIsUngatedForDisplayOptimizedFormControl } from '../v2/hooks/useIsUngatedForDisplayOptimizedFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import { createTokenizedComponent, withoutClassName } from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
export let _capturedPropsForTesting = {};
const TokenizedUITextInput = createTokenizedComponent(UITextInput);
export default function TextInputAdapter(_ref) {
  let {
      defaultValue,
      use
    } = _ref,
    commonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isUngatedForDisplayOptimizedFormControl = useIsUngatedForDisplayOptimizedFormControl();
  if (isUngatedForDisplayOptimizedFormControl) {
    const rest = withoutClassName(commonProps);
    _capturedPropsForTesting = Object.assign({
      defaultValue,
      use
    }, rest);
    return /*#__PURE__*/_jsx(TextInput, Object.assign({
      "data-test-id": "TextInput",
      defaultValue: defaultValue,
      use: use
    }, rest));
  }
  const adaptedDefaultValue = defaultValue !== undefined ? typeof defaultValue === 'number' ? String(defaultValue) : defaultValue : undefined;
  const adaptedUse = use === 'default' || use === 'on-dark' ? use : undefined;
  _capturedPropsForTesting = Object.assign({
    defaultValue: adaptedDefaultValue,
    use: adaptedUse
  }, commonProps);
  return /*#__PURE__*/_jsx(TokenizedUITextInput, Object.assign({
    "data-test-id": "UITextInput",
    defaultValue: adaptedDefaultValue,
    use: adaptedUse
  }, commonProps));
}